import React from 'react';
import { Grid, Fab } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import Search from 'Console/components/common/search/Search';

const GuideSearch = ({ searchTerm, intl, handleGuideSearch }): React.ReactElement => (
    <>
        <Grid style={{ width: '17rem' }}>
            <Search
                id="form-item-search"
                placeholder={intl.formatMessage({
                    id: 'Guides.searchPlaceholder',
                })}
                onChange={handleGuideSearch}
                value={searchTerm}
            />
        </Grid>
        <Fab color="primary" aria-label="Search" style={{ marginLeft: '15px' }}>
            <SearchIcon />
        </Fab>
    </>
);

export default GuideSearch;
